export default function buildPatchProducerApplications({
    apiEndpoint,
    apiTools
}) {
    return async function patchProducerApplications(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/approve`
        })
       
        const res = await fetch(url, {
            method: 'PATCH',
            credentials: 'include',
        });
        return await res.json();
    }
}